
export type POIModelPoiType = typeof POIModelPoiType[keyof typeof POIModelPoiType];


export const POIModelPoiType = {
  PlanarFace: 'PlanarFace',
  StraightWall: 'StraightWall',
} as const;
